const $ = jQuery.noConflict();

'use strict';
const PropertySingle = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		const currentPriceText = $('.updateable_current-price').text().replace(',', '');
		//this.watchButton();
		this.quntityInput();
		this.auctionRegister();
		if ($('.class-register-disabled').length > 0) {
			$('.js-buy-now').show();
		}

		$('.js-success-trigger').on('click', function() {
			if ($('.js-success').length > 0) {
				$('.js-buy-now').show();
				$('.js-success-trigger').text('Allready registered');
			} else {
				setTimeout(function() {
					$('.js-buy-now').show();
					$('.js-success-trigger').text('Allready registered');
				}, 100);
			}
		});

		$('.js-view-gallery').on('click', function() {
			$('.js-slider-popup').addClass('active');
			$('.property').css({
				'z-index': '9999'
			});
			$('body').addClass('prevent-scroll');
		});
		$('.js-close-gallery').on('click', function() {
			$('.js-slider-popup').removeClass('active');
			$('.property').css({
				'z-index': '2'
			});
			$('body').removeClass('prevent-scroll');
		});
		// Function to handle changes to the quantity input
		function handleQuantityInputChange() {
			const stepValue = $('.quantity-input').prop('step') !== undefined && $('.quantity-input').prop('step') !== '' ? parseFloat($('.quantity-input').prop('step')) : 1;
			const userFunds = parseFloat($('.quantity-input').prop('max') !== undefined && $('.quantity-input').prop('max') !== '' ? $('.quantity-input').prop('max').replace(/[$,]/g, '') : 0);
			const isBiddingOther = parseInt($('.quantity-input').data('other_bids') !== undefined && $('.quantity-input').data('other_bids') !== '' ? $('.quantity-input').data('other_bids') : 0);
			const isHighest = parseInt($('.quantity-input').data('current_highest') !== undefined && $('.quantity-input').data('current_highest') !== '' ? $('.quantity-input').data('current_highest') : 0);
			const inputedVal = parseFloat(PropertySingle.formatNumber($('.quantity-input').val().replace(/[$,]/g, '')));
			const minimumVal = parseFloat(PropertySingle.formatNumber(currentPriceText.replace(/[^\d.]/g, ''))) + stepValue;
			if (inputedVal >= minimumVal && inputedVal <= userFunds && !isHighest) {
				if (!$('.quantity-btn-bid').hasClass('js-popup-bid-trigger')) {
					$('.quantity-btn-bid').addClass('js-popup-bid-trigger');
				}
				$('.custom-bid_error-holder').html('');
				$('.bid_button').prop('disabled', false); // Enable button if bid is valid
			} else if(inputedVal >= minimumVal && inputedVal <= userFunds && isHighest) {
				$('.custom-bid_error-holder').html('You are highest bidder');
				$('.bid_button').prop('disabled', true);
			} else if (inputedVal > userFunds) {
				$('.quantity-btn-bid').removeClass('js-popup-bid-trigger');
				$('.quantity-btn-bid').addClass('js-warning-trigger');
				if(userFunds <= 0 && !isBiddingOther){
					$('.custom-bid_error-holder').html('This bid amount exceeds your approved funds.');
					$('.custom_hidden-warning').trigger('click');
				} else {
					if(isBiddingOther > 0){
						$('.custom-bid_error-holder').html('You are already bidding on an auction. This bid amount exceeds your approved funds.');
					} else {
						//$('.custom-bid_error-holder').html('Bid is larger than proof of funds. Current max bid is $' + PropertySingle.formatNumber(userFunds));
						$('.custom-bid_error-holder').html('This bid amount exceeds your approved funds.');
					}
				}
				$('.bid_button').prop('disabled', true); // Disable button if bid is too high
			} else {
				$('.quantity-btn-bid').removeClass('js-popup-bid-trigger');
				$('.custom-bid_error-holder').html('Bid needs to be at least $' + PropertySingle.formatNumber(minimumVal));
				$('.bid_button').prop('disabled', true); // Disable button if bid is too low
			}
		}

		// Set up MutationObserver to detect when the button is added to the DOM
		const observer = new MutationObserver((mutationsList) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'childList') {
					for (const addedNode of mutation.addedNodes) {
						if ($(addedNode).is('.bid_button')) {
							// Attach the change event handler to the quantity input
							$('.quantity-input').on('change', handleQuantityInputChange);
							// Call the handler to ensure the initial state is set correctly
							handleQuantityInputChange();
						}
					}
				}
			}
		});

		// Start observing the document for child elements being added
		observer.observe(document.body, {childList: true, subtree: true});

		// Call the handler in case the elements are already present
		$(document).ready(() => {
			if ($('.bid_button').length) {
				$('.quantity-input').on('change', handleQuantityInputChange);
				//handleQuantityInputChange();
			}
		});
	},

	/** @description slider example description e.g Banner slider */
	watchButton: () => {
		if ($(window).width() < 576) {
			$('.js-property-details-top').append($('.js-btn-watch-mobile'));
		}
	},

	quntityInput: () => {
		$('.js-minus').on('click', function() {
			const $input = $(this).parent().find('.quantity-input');
			const stepValue = $input.prop('step') !== undefined && $input.prop('step') !== '' ? $input.prop('step') : 1;
			const finalStepup = parseFloat($input.val().replace(/[$,]/g, '')) - parseFloat(stepValue);

			const count = finalStepup < 1 ? 1 : finalStepup;
			$input.val('$' + PropertySingle.formatNumber(count));
			$input.trigger('change');
			return false;
		});

		$('.js-plus').on('click', function() {
			const $input = $(this).parent().find('.quantity-input');
			const stepValue = $input.prop('step') !== undefined && $input.prop('step') !== '' ? $input.prop('step') : 1;
			const finalStepup = parseFloat($input.val().replace(/[$,]/g, '')) + parseFloat(stepValue);

			$input.val('$' + PropertySingle.formatNumber(finalStepup));
			$input.trigger('change');
			return false;
		});
	},

	formatNumber: (number) => {
		return number.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
	},

	auctionRegister: () => {
		$('.property_register-auction').on('click', function() {
			// Check if the user is logged in
			if (isLoggedIn()) {
				const currentAuctionStatus = $('.property__details .js-property-status').text();

				// Check if user funds are sufficient
				if (areFundsSufficient()) {
					// Get the product ID of the current product
					const productId = $('#current_product_id').val();
					// Get the user ID of the currently signed-in user
					const userId = $('#current_user_id').val();

					// Make AJAX call
					$.ajax({
						url: window.fwsLocalized.ajaxUrl,
						type: 'POST',
						data: {
							action: 'registered_auctions',
							currentStatus: currentAuctionStatus.trim(),
							productId: productId,
							userId: userId
						},
						success: function() {
							if(currentAuctionStatus.trim() === 'Live auction') {
								$('.property_register-auction').removeClass('js-success-trigger');
								location.reload();
							} else {
								//$('.js-success').show();
							}
						},
						error: function() {
							// Handle error
						}
					});
				}
			} else {
				// User is not logged in, redirect to login page
				const baseUrl = window.location.origin;
				const currentUrl = window.location.href;
				window.location.href = `${baseUrl}/my-account?redirect=${encodeURIComponent(currentUrl)}`;
			}
		});

		// Function to check if the user is logged in
		function isLoggedIn() {
			return $('body').hasClass('logged-in');
		}

		// Function to check if user funds are sufficient
		function areFundsSufficient() {
			// Get the value of the current user's funds
			const userFunds = parseFloat($('#current-user-funds').val());

			// Get the value of the current price
			const currentPrice = parseFloat($('#comparable-price').val());

			// Check if user funds are greater than or equal to the required amount
			return userFunds >= currentPrice;
		}
	},
};

export default PropertySingle;